import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/settings')({
  component: SettingsPage,
});

function SettingsPage() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">Configurações da Plataforma</h1>
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-8">
          <div className="text-center">
            <p className="text-xl text-gray-600 dark:text-gray-400">Em breve</p>
            <p className="text-gray-500 dark:text-gray-500 mt-2">As configurações da plataforma estarão disponíveis em breve.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

